module.exports = __webpack_public_path__ + "static/media/layout2-vid.d6c780d0.svg";